<template>

    <div class="ibox col-md-12 border-0 pb-1">
        <div
            class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
            <h4 class="clearfix">
                <span class="float-left">Provident Contribution History for accordHRM
                    <span class="title-sub-text">Get a clear picture of your PF
                        Contribution.
                        Use this information to better understand your workforce.
                    </span>
                </span>
                <span class="float-right">
                </span>
            </h4>
        </div>

        <div class="ibox col-md-12 border-0">
            <div class="ibox-content pf-overview pl-0 pt-3 pb-0 pr-3"> <!-- MUstafijur: 23-05-2026: Added: pt-3 pb-pb-0 pr-3 -->
                <div class="payslip-details-info-inner row pb-2"> <!-- MUstafijur: 23-05-2026: Added: pt-3 pb-2 -->
                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0">
                            <div class="col-md-6">
                                <div class="first pt-2">Available Forfeiture Fund</div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.available_ff_fund) }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0">
                            <div class="col-md-6">
                                <div class="first pt-2">Total Distributed Forfeiture</div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.company_ff_distributed_amount)}}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0">
                            <div class="col-md-6">
                                <div class="first pt-2">Total Distributed Forfeiture Reclaim
                                </div>
                            </div>
                            <div class="col-md-6 text-right px-0"> <!-- Mustafijur: 23-05-2026: Added: px-0 -->
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.total_distributed_reclaim) }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0">
                            <div class="col-md-6">
                                <div class="first pt-2">Total Distributed Profit</div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.total_distributed_profit) }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0">
                            <div class="col-md-6">
                                <div class="first pt-2">Total Distributed Loan</div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.total_refunded_loan) }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0">
                            <div class="col-md-6">
                                <div class="first pt-2">Total Refunded Loan</div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.total_refunded_loan) }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0 susd">
                            <div class="col-md-6">
                                <div class="first pt-2 text_color">
                                    <strong>Employee</strong>
                                    contribution till date
                                </div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second text_color">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second text_color">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.total_employee_contribution) }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0 susd">
                            <div class="col-md-6">
                                <div class="first pt-2 text_color"><strong>Employer</strong>
                                    contribution till date</div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second">
                                    <template v-if="pf_history_loading">
                                        <div class="second text_color">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second text_color">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney(company_pf_history.total_employer_contribution) }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 payslip-details-info-right">
                        <div class="wrapper d-flex pl-0 susd">
                            <div class="col-md-6">
                                <div class="first pt-2 text_color">Receivable from
                                    <strong>Employee</strong>
                                </div>
                            </div>
                            <div class="col-md-6 text-right px-0">
                                <div class="second text_color">
                                    <template v-if="pf_history_loading">
                                        <div class="second">Calculating</div>
                                    </template>
                                    <template v-else>
                                        <div class="second text_color">
                                            <span class=""
                                                style="font-size: 25px;">৳</span>
                                            {{ formatMoney('0000') }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            company_pf_history: [{ available_ff_fund: 0, company_ff_fund: 0 }],
            pf_history_loading: true,
        }
    },
    methods: {
        getCompanyPFData: function () {
            let currentObj = this;
            let formData = new FormData();
            axios.post(this.$api_url+'/pf/get-company-pf-data', formData)
              .then(function (response) {
                    this.pf_history_loading = false;
                    this.company_pf_history = response.data;
                    this.company_pf_history.available_ff_fund = this.company_pf_history.company_ff_fund;
                }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
    },

    mounted() {
        this.getCompanyPFData();
    },
}
</script>
